import menuBlackAnalyzed from "assets/ic_analyzed.svg";
import back from "assets/ic_back.png";
import menuBlack from "assets/ic_menu_black.webp";
import logoBlack from "assets/logo_saveit.webp";
import { addShake, toWindowUrl } from "helper/functionalHelper";
import { SaveItLocalStorage } from "helper/storageHelper";
import AppURLs from "pages/AppInfo/AppUrl";
import BbcRoute from "pages/BBC/BbcRoute";
import { useHeaderStore, useSideBar } from "pages/Common/AppState";
import MSCRoute from "pages/MSC/MscRoute";
import vatRoutes from "pages/Vat/vatRoute";
import YecRoutes from "pages/YEC/YecRoute";
import React, { useEffect, useMemo } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import "./MobileHeader.scss";

const MobileHeader = () => {
  const { setSideBarOpen } = useSideBar();
  const history = useHistory();
  const { pathname, state } = useLocation();
  const { title, showMenu } = useHeaderStore();

  const showLogo = useMemo(() => {
    switch (pathname) {
      case "/":
      case BbcRoute.BBCMain.url:
        return true;
      default:
        return false;
    }
  }, [pathname]);

  const headerTitle = useMemo(() => {
    switch (pathname) {
      case "/payment":
        return "이용권 결제";
      case vatRoutes.reportResult.url:
        return "나의 신고 내역";
      case vatRoutes.report.url:
        return "신고 내용";
      case AppURLs.cit.report.list:
        return "나의 이용권";
      case YecRoutes.yecSummary.url:
        return "연말정산계산기";
      case AppURLs.yes.root:
        return "결과 조회";
      case AppURLs.upc.root:
        return "실업급여계산기";
      case AppURLs.rpc.root:
        return "퇴직금계산기";
      default:
        return title;
    }
  }, [pathname, title]);

  const handleBack = () => {
    if (state?.from === "kakao-login") {
      toWindowUrl();
    } else if (state?.from === "vat-complete-report") {
      toWindowUrl("/#/vat");
    } else {
      switch (pathname) {
        case AppURLs.yec.root:
        case AppURLs.rpc.root:
        case AppURLs.upc.root:
        case YecRoutes.prevYearAnalysis.url:
        case MSCRoute.MSCSummary.url:
          toWindowUrl();
          break;
        default:
          history.goBack();
          break;
      }
    }
  };

  const isAnalyzed = useMemo(() => {
    const tempAnalyzed = SaveItLocalStorage.getIsAnalyzed();
    return tempAnalyzed === "true";
  }, []);

  useEffect(() => {
    if (isAnalyzed) {
      const timerId = addShake("#menu-shake", 2);
      return () => {
        clearTimeout(timerId);
      };
    }
  }, [isAnalyzed]);

  return (
    <header className="header-container px-2">
      {showLogo ? (
        <Link to="/">
          <img src={logoBlack} alt="" height={40} />
        </Link>
      ) : (
        !state?.hideBackButton && (
          <div
            className="h-100 d-flex hover"
            style={{ aspectRatio: "1" }}
            onClick={handleBack}
          >
            <img src={back} alt="" width={25} className="m-auto" />
          </div>
        )
      )}
      <h1 className="text-center fw-bold fs-5 mb-0">{headerTitle}</h1>
      {/* <div id="menu-shake">
        {showMenu && (
          <Button
            color="light"
            style={{ backgroundColor: "transparent", border: "none" }}
            onClick={() => setSideBarOpen(true)}
          >
            {isAnalyzed ? (
              <img
                className="ic-analyzed"
                src={menuBlackAnalyzed}
                alt=""
                width={28}
              />
            ) : (
              <img src={menuBlack} alt="" width={20} />
            )}
          </Button>
        )}
      </div> */}
    </header>
  );
};

export default MobileHeader;
